// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wxFB","toggle":"styles_toggle__3kiGS","preview":"styles_preview__2T6Vt"};